import { ReactNode } from 'react';
import { SellerTopNavigation } from './SellerTopNavigation';

interface DesktopSellerPageContainerProps {
  children: ReactNode;
  className?: string;
}

export function DesktopSellerPageContainer({ 
  children, 
  className = ''
}: DesktopSellerPageContainerProps) {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      {/* 상단 네비게이션 */}
      <SellerTopNavigation />
      
      {/* 메인 콘텐츠 영역 - 상단 네비게이션 높이만큼 패딩 */}
      <main className="pt-[72px]">
        <div 
          className={`min-h-[calc(100vh-72px)] bg-white ${className}`}
          style={{ 
            paddingTop: '24px',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '24px'
          }}
        >
          {children}
        </div>
      </main>
    </div>
  );
}